import type {UpdateUserFormPayload} from "./update-user.schema";
import type {UpdateUserRequest} from "@project/sdk/admin";

export const updateUserMapper = {
  toSdk: (payload: UpdateUserFormPayload): UpdateUserRequest => ({
    name: payload.name,
    email: payload.email,
    role: payload.role,
    bio: payload.bio,
    seniority: payload.seniority,
    department: payload.department,
    isActive: payload.isActive,
  }),
};
